import {
    Box,
    Button,
    Card,
    CardBody,
    Checkbox,
    Flex,
    Heading,
    IconButton,
    Input,
    Stack,
    Text, useDisclosure, useToast
} from "@chakra-ui/react";
import { Checklist, CheckListArea, UserAnswer } from "../../interfaes/iep";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { addNewCheckList, completeIEPStep, deleteQuestion, onSaveAnswers } from "../../http/iepAPis";
import _findIndex from 'lodash/findIndex';
import { useNavigate } from "react-router-dom";
import CoustomAlertDialog from "../../components/CoustomAlertDialog";
import _groupBy from "lodash/groupBy";
import { canAddStudent } from "../../utils/common";
import _find from "lodash/find";
import { MdDelete } from "react-icons/md";



type CheckListAreasPropsType = {
    checkListArea: CheckListArea[]
    checkListAreaOld: CheckListArea[]
    iepId: string
    title: string
    subTitle: string
    onGetData: () => void;
    step: number;
    isCompleted: boolean | undefined;
};
export default function CheckListAreas({ checkListArea, checkListAreaOld, iepId, title, subTitle, onGetData, step, isCompleted }: CheckListAreasPropsType) {
    const { t } = useTranslation('iep');
    const [checklist, setChecklist] = useState<Checklist[]>(checkListArea ? checkListArea[0].checklist : []);
    const [selectedIndex, setSelectedIndex] = useState<string>(checkListArea[0].section);
    const [group, setGroup] = useState<string>(checkListArea[0].group);
    const [questionID, setQuestionID] = useState<string>('');
    const navigate = useNavigate();
    const [checkBoxAnswers, setCheckBoxAnswers] = useState(new Map());
    const [remarks, setRemarks] = useState(new Map());
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [loading, setLoading] = useState(false);
    const [newCheckList, setNewCheckList] = useState('');



    const handleSave = async (userAnswers: UserAnswer, qId: string) => {



        try {
            await onSaveAnswers(userAnswers);
            const userIndex = _findIndex(checklist, { 'questionId': qId });
            let updatedCheckList = checklist;
            if (userIndex !== -1) {
                updatedCheckList[userIndex].withAnswer = true;
            }
            setChecklist([...updatedCheckList]);
            setTimeout(() => {
                onGetData();
            }, 5000)

        } catch (e) {
            console.log(e)
        } finally {
            setQuestionID('');
        }





    }
    useEffect(() => {
        checklist.forEach((e) => {
            setCheckBoxAnswers((prevMap) => {
                const newMap = new Map(prevMap);
                if (e.answer) {
                    newMap.set(e.questionId, e.answer.content)
                }

                return newMap;

            });
            setRemarks((prevMap) => {
                const newMap = new Map(prevMap);
                if (e.answer) {
                    newMap.set(e.questionId, e.answer.remarks)
                }
                return newMap;

            });
        })
    }, [checklist])

    const toast = useToast()


    const handleClose = () => {

        onClose();
        setqId(undefined);


    }

    const onCompleteIEP = async () => {
        try {
            setLoading(true)
            if (qId) {
                await deleteQuestion(qId ? qId : '');
                toast({
                    title: 'CheckList Removed',
                    description: "CheckList removed Successfully!!!",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
                setqId(undefined);
                setLoading(false);
                onClose();
            } else {
                await completeIEPStep(iepId, step, !isCompleted);
                setTimeout(() => {
                    onGetData();
                }, 5000)
                toast({
                    title: 'CheckList Completed',
                    description: "CheckList completed Successfully!!!",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
                onClose();
            }
        } catch (e) {
            toast({
                title: 'CheckList Failed',
                description: "CheckList could not be completed!!!",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })
            console.log(e)
        } finally {
            setLoading(false);
            if (!qId) navigate(-1);
        }


    }
    const onAddNewQuestions = async () => {

        const obj = {
            "iepId": iepId,
            "group": group,
            "section": selectedIndex,
            "question": newCheckList,
            "questionNP": newCheckList,
            "questionType": "YES_NO",
            "options": [
                "आफै गर्न सक्छ",

                "कठिनाइ छ",

                "उस्लाई मिल्दैन"
            ],
            "position": 0,
            "iepStep": 2,
        };
        try {
            setLoading(true)
            await addNewCheckList(obj);

            onGetData();

            setNewCheckList('');

            toast({
                title: 'Checklist Added',
                description: "CheckList Added Successfully!!!",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })
        } catch (e) {
            toast({
                title: 'CheckList Add Failed',
                description: "CheckList could not be added!!!",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })
            console.log(e)
        } finally {
            setLoading(false);
        }

    }

    const getStepTwoAnswer = (qId: String) => {
        const ans = _find(_find(checkListAreaOld, { 'checklist': [{ 'questionId': 'Q-S2-00001' }] })?.checklist, ['questionId', qId.replace('-F', '')]);
        if (ans?.answer?.content === 'Can') {
            return 'आफै गर्न सक्छ';
        }
        if (ans?.answer?.content === 'Cannot') {
            return 'कठिनाइ छ';
        }
        if (ans?.answer?.content === 'Not possible') {
            return 'उस्लाई मिल्दैन';
        }

    }
    const [qId, setqId] = useState<string | undefined>(undefined);

    return (
        <Box mt={'24px'}>
            <Box mb={6} pb={4} borderBottom="1px solid" borderColor="gray.100">
                <Text fontWeight={'900'} fontSize={{ base: '20px', md: '24px' }} color="blue.600">
                    {title} : {subTitle}
                </Text>
            </Box>

            <Box>
                {Object.entries(_groupBy(checkListArea, 'group')).map(([key, value]) => (
                    <Box key={key} mb={6}>
                        <Text fontWeight={'700'} fontSize={'16px'} color={'blue.500'} mb={4} textTransform="uppercase" letterSpacing="wider">
                            {key}
                        </Text>
                        <Flex flexWrap="wrap" gap={3}>
                            {value.map((c) => (
                                <Box
                                    key={c.section}
                                    px={4}
                                    py={2}
                                    borderRadius="full"
                                    bg={selectedIndex === c.section ? 'blue.600' : 'white'}
                                    color={selectedIndex === c.section ? 'white' : 'gray.600'}
                                    border="1px solid"
                                    borderColor={selectedIndex === c.section ? 'blue.600' : 'gray.200'}
                                    cursor="pointer"
                                    fontWeight="600"
                                    fontSize="md"
                                    transition="all 0.2s"
                                    _hover={{ bg: selectedIndex === c.section ? 'blue.700' : 'gray.50' }}
                                    onClick={() => {
                                        setChecklist(c.checklist);
                                        setSelectedIndex(c.section);
                                        setGroup(c.group);
                                        setNewCheckList('');
                                    }}
                                >
                                    {c.section}
                                </Box>
                            ))}
                        </Flex>
                    </Box>
                ))}
            </Box>

            <Card mt={'24px'} borderRadius="2xl" overflow="hidden" variant="outline" boxShadow="sm">
                <Box overflowX="auto">
                    <Box minW="800px">
                        <Flex background={'blue.600'} px={4} py={3} color="white">
                            <Text w={step === 2 ? '42%' : '40%'} fontWeight={'700'}>ACTIVITIES</Text>
                            {step === 7 && <Text w={'7%'} fontWeight={'700'}>PREVIOUS</Text>}
                            <Text w={'10%'} fontWeight={'700'} textAlign="center">CAN</Text>
                            <Text w={'10%'} fontWeight={'700'} textAlign="center">DIFFICULT</Text>
                            <Text w={'10%'} fontWeight={'700'} textAlign="center">N/A</Text>
                            <Text w={step === 2 ? '20%' : '15%'} fontWeight={'700'}>REMARKS</Text>
                            <Text w={'8%'} fontWeight={'700'} textAlign="center">ACTION</Text>
                        </Flex>

                        <Stack spacing={0} divider={<Box borderBottom="1px solid" borderColor="gray.100" />}>
                            {checklist.length > 0 && checklist.map((c, index) => (
                                <Flex key={c.questionId} p={4} alignItems={'center'} transition="bg 0.2s" _hover={{ bg: "gray.50" }}>
                                    <Text w={step === 2 ? '42%' : '40%'} fontWeight={'600'} fontSize={'14px'}>
                                        {c.question}
                                    </Text>
                                    {step === 7 && (
                                        <Text w={'7%'} fontSize={'14px'} color="gray.500">
                                            {getStepTwoAnswer(c.questionId)}
                                        </Text>
                                    )}
                                    {c.options.map((o) => (
                                        <Flex key={o} w={'10%'} justifyContent="center">
                                            <Checkbox
                                                colorScheme='blue'
                                                size="lg"
                                                isChecked={checkBoxAnswers.get(c.questionId) === o}
                                                isDisabled={isCompleted || !canAddStudent()}
                                                _disabled={{ opacity: 1, cursor: 'not-allowed' }}
                                                onChange={() => {
                                                    setCheckBoxAnswers((prevMap) => {
                                                        const newMap = new Map(prevMap);
                                                        newMap.set(c.questionId, o)
                                                        return newMap;
                                                    });
                                                    setQuestionID(c.questionId);
                                                    const answer = {
                                                        questionId: c.questionId,
                                                        iepId: iepId,
                                                        type: "YES_NO",
                                                        content: [o],
                                                        remarks: remarks.get(c.questionId) || ""
                                                    }
                                                    handleSave(answer, c.questionId)
                                                }}
                                            />
                                        </Flex>
                                    ))}

                                    <Box w={'20%'} px={1}>
                                        <Input
                                            isDisabled={isCompleted || !canAddStudent()}
                                            _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                                            value={remarks.get(c.questionId) || ''}
                                            onChange={(e) => {
                                                setRemarks((prevMap) => {
                                                    const newMap = new Map(prevMap);
                                                    newMap.set(c.questionId, e.target.value)
                                                    return newMap;
                                                });
                                            }}
                                            variant="flushed"
                                            fontSize="14px"
                                        />
                                    </Box>

                                    <Flex w={'8%'} justifyContent="center" alignItems="center" gap={2}>
                                        {remarks.get(c.questionId) && (
                                            <Button
                                                size="sm"
                                                colorScheme="green"
                                                onClick={() => {
                                                    setQuestionID(c.questionId);
                                                    const answer = {
                                                        questionId: c.questionId,
                                                        iepId: iepId,
                                                        type: "YES_NO",
                                                        content: [checkBoxAnswers.get(c.questionId)],
                                                        remarks: remarks.get(c.questionId)
                                                    }
                                                    handleSave(answer, c.questionId)
                                                }}
                                                isLoading={c.questionId === questionID}
                                                isDisabled={!checkBoxAnswers.get(c.questionId) || isCompleted}
                                            >
                                                Done
                                            </Button>
                                        )}
                                        {c.custom && (
                                            <IconButton
                                                aria-label="Delete"
                                                icon={<MdDelete />}
                                                size="sm"
                                                variant="ghost"
                                                colorScheme="red"
                                                onClick={() => {
                                                    setqId(c.questionId);
                                                    onOpen();
                                                }}
                                            />
                                        )}
                                    </Flex>
                                </Flex>
                            ))}
                        </Stack>
                    </Box>
                </Box>

                {step === 2 && (
                    <Box p={4} bg="gray.50" borderTop="1px solid" borderColor="gray.200">
                        <Text mb={3} fontWeight={'700'} fontSize={'15px'} color="gray.700">Add New Check List</Text>
                        <Flex gap={3}>
                            <Input
                                flex={1}
                                isDisabled={isCompleted || !canAddStudent()}
                                _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed' }}
                                value={newCheckList}
                                onChange={(e) => setNewCheckList(e.target.value)}
                                bg="white"
                            />
                            <Button
                                colorScheme={"blue"}
                                onClick={onAddNewQuestions}
                                isLoading={loading}
                                isDisabled={loading || newCheckList === ''}
                                borderRadius="lg"
                            >
                                Add item
                            </Button>
                        </Flex>
                    </Box>
                )}
            </Card>

            <Flex mt={'32px'} direction={{ base: 'column', md: 'row' }} gap={4} justifyContent={'flex-end'}>
                <Button
                    variant="ghost"
                    size='lg'
                    onClick={() => navigate(-1)}
                    borderRadius="xl"
                >
                    {t('back')}
                </Button>

                <Button
                    colorScheme={isCompleted ? 'orange' : 'green'}
                    size='lg'
                    onClick={() => onOpen()}
                    borderRadius="xl"
                    boxShadow="sm"
                >
                    {isCompleted ? t('redoStep') : t('completeStep')}
                </Button>
            </Flex>

            <CoustomAlertDialog
                onClose={handleClose}
                onOpen={onOpen}
                isOpen={isOpen}
                onMainAction={onCompleteIEP}
                loading={loading}
                warning={qId ? false : true}
            />

        </Box>
    );
}
